import "./style.less";

export default function InputUserRole() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            validation: "=",
            label: "@",
            model: "=",
            roles: "<",
        },

        template: require("./template.html"),

        controller: function ($scope) {
            $scope.model = $scope.roles[0]; // Default the first one
            $scope.setRole = (role) => {
                $scope.model = role;
            };
        },
    };
}
